import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-promos-welcome-slide',
  templateUrl: './welcome-slide.component.html',
  styleUrl: './welcome-slide.component.scss',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeSlideComponent {}
